// Tabs collections carousel - basic functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Basic initialization - let the theme handle navigation
  function initializeTabs() {
  }
  
  // Initialize on load
  initializeTabs();
  
  // Initialize on section load
  document.addEventListener('shopify:section:load', function(event) {
    initializeTabs();
  });
});
